import { ActionTypes } from '../constants/index';


export function getCards(): Object {
  return {
    type: ActionTypes.PAYMENT_GET_REQUEST,
    payload: {},
  };
}

export function addCard(cardToken: string): Object {
  return {
    type: ActionTypes.PAYMENT_ADD_REQUEST,
    payload: { cardToken },
  };
}

export function clearCardError(): Object {
  return {
    type: ActionTypes.PAYMENT_CLEAR_CARD_ERROR,
    payload: {},
  };
}

export function makePrimaryCard(cardid: string): Object {
  return {
    type: ActionTypes.PAYMENT_PRIMARY_REQUEST,
    payload: { cardid },
  };
}

export function deleteCard(cardid: string): Object {
  return {
    type: ActionTypes.PAYMENT_DELETE_REQUEST,
    payload: { cardid },
  };
}



// WEBPACK FOOTER //
// ./scripts/actions/payment.js